import Vue from 'vue'
import {
    statelocalstorage
} from '../utils/statelocalstoreage'
import * as commitTypes from './commitTypes'
export const mutations = {
    user(state, user) {
        state.user = user
        statelocalstorage(state)
    },
    client(state, client) {
        const cleanClient = !!client ?
            {
                ...client,
                structures: [],
            } :
            null
        state.client = cleanClient
        statelocalstorage(state)
    },
    state(state, data) {
        Object.keys(data).map(key => {
            Vue.set(state, key, data[key])
            // state[key] = data[key];
        })
        statelocalstorage(state)
    },
    structures(state, data) {
        if (!!state.client) {
            state.client.structures = data
        }
        statelocalstorage(state)
    },
    personEntries(state, entries) {
        state.personEntries = entries
        // statelocalstorage(state);
    },
    accessPoint(state, structure) {
        state.accessPoint = structure
        statelocalstorage(state)
    },
    alarms(state, alarms) {
        state.alarms = alarms
        // statelocalstorage(state);
    },
    setAlarmedEntry(state, entry) {
        let index = state.entries.findIndex(item => item.id === entry.id)
        entry.alarmReported = true
        state.entries[index] = entry
        // statelocalstorage(state);
    },
    notes(state, notes) {
        state.notes = notes
        statelocalstorage(state)
    },
    mail(state, mail) {
        // let m = typeof mail === 'array'? mail: [];
        state.mail = mail
        // statelocalstorage(state);
    },
    shift(state, shift) {
        state.shift = shift
        statelocalstorage(state)
    },
    assignedClients(state, clients) {
        state.assignedClients = clients
        // statelocalstorage(state);
    },
    otherClients(state, clients) {
        state.otherClients = clients
        // statelocalstorage(state);
    },
    vehicleEntries(state, entries) {
        state.vehicleEntries = entries
        // statelocalstorage(state);
    },
    startProcessing(state) {
        // state.inProgress = true;
        // statelocalstorage(state);
    },
    stopProcessing(state) {
        // state.inProgress = false;
        // statelocalstorage(state);
    },
    selectedUser(state, user) {
        state.selectedUser = user
        // statelocalstorage(state);
    },
    setCurrentMenu(state, menu) {
        state.currentMenu = menu
        statelocalstorage(state)
    },
    setMenuOptions(state, options) {
        state.menuOptions = options
        statelocalstorage(state)
    },
    addLoaded(state, key) {
        !state.loaded.includes(key) && state.loaded.push(key)
        statelocalstorage(state)
    },
    [commitTypes.SET_CLIENTS](state, clients) {
        state.clients = clients
        // statelocalstorage(state);
    },
    [commitTypes.SET_VALID_YEARS](state, years) {
        state.years = years
        statelocalstorage(state)
    },
    [commitTypes.SET_MONTHS](state, months) {
        state.months = months
        statelocalstorage(state)
    },
    [commitTypes.SET_POSITIONS](state, positions) {
        state.positions = positions
        statelocalstorage(state)
    },
    [commitTypes.SET_VEHICLE_ENTRY_MASTER_DATA](state, masterData) {
        state.vehicleTypes = masterData.vehicleTypes
        state.vehicleEntryTypes = masterData.vehicleEntryTypes
        statelocalstorage(state)
    },
    [commitTypes.SET_VISITOR_TYPES](state, visitorTypes) {
        state.visitorTypes = visitorTypes
        statelocalstorage(state)
    },
    [commitTypes.SET_PASSENGER_TYPES](state, passengerTypes) {
        state.passengerTypes = passengerTypes
        statelocalstorage(state)
    },
    [commitTypes.SET_ALERT_NOTIFICATIONS](state, notifications) {
        state.alertNotifications = notifications
        // statelocalstorage(state);
    },
    [commitTypes.SET_SUPERVISOR](state, supervisor) {
        state.supervisor = supervisor
        statelocalstorage(state)
    },
    [commitTypes.SET_ANNOTATION_TYPES](state, annotationTypes) {
        state.annotationTypes = annotationTypes
        statelocalstorage(state)
    },
    [commitTypes.SET_CITIES](state, cities) {
        state.cities = cities
        // statelocalstorage(state);
    },
    [commitTypes.SET_VEHICLE_TYPES](state, types) {
        state.vehicleTypes = types
        statelocalstorage(state)
    },
    [commitTypes.SET_IDENTIFICATION_TYPES](state, types) {
        state.identificationTypes = types
        statelocalstorage(state)
    },
    [commitTypes.SET_CLIENT_TYPES](state, types) {
        state.clientTypes = types
        statelocalstorage(state)
    },
    [commitTypes.SET_TOOLS](state, tools) {
        state.tools = tools
        // statelocalstorage(state);
    },
    [commitTypes.SET_PROFILES](state, profiles) {
        state.profiles = profiles
        statelocalstorage(state)
    },
    [commitTypes.SET_MAIL_TYPES](state, types) {
        state.mailTypes = types
        statelocalstorage(state)
    },
    [commitTypes.SET_STRUCTURE_TYPES](state, types) {
        state.structureTypes = types
        statelocalstorage(state)
    },
    [commitTypes.SET_PETITION_STATUSES](state, statuses) {
        state.petitionStatuses = statuses
        statelocalstorage(state)
    },
    [commitTypes.SET_PETITION_TYPES](state, types) {
        state.petitionTypes = types
        statelocalstorage(state)
    },
    [commitTypes.SET_ITEM_TYPES](state, types) {
        state.itemTypes = types
        statelocalstorage(state)
    },
    [commitTypes.SET_ADMINISTRATIVE_USERS](state, users) {
        state.administrativeUsers = users
        // statelocalstorage(state);
    },
    [commitTypes.SET_RESTRICTED_VISITORS](state, visitors) {
        state.restrictedVisitors = visitors
        // statelocalstorage(state);
    },
    [commitTypes.SET_CAPABILITIES](state, capabilities) {
        state.capabilities = capabilities
        statelocalstorage(state)
    },
    [commitTypes.SET_SELECTED_STORE](state, store) {
        state.selectedStore = store
    },
    [commitTypes.SET_SELECTED_BODYGUARD_SERVICE](state, bodyguardService) {
        state.selectedBodyguardService = bodyguardService
    },
    [commitTypes.SET_PEOPLE](state, people) {
        state.people = people
    },
    [commitTypes.SET_SELECTED_ROUND](state, round) {
        state.selectedRound = round
    },
    [commitTypes.SET_EXECUTIVES](state, executives) {
        state.executives = executives
    },
    [commitTypes.SET_ARLS](state, arls) {
        state.arls = arls
    },
    [commitTypes.SET_SUPERVISORS](state, supervisors) {
        state.supervisors = supervisors
    },
    [commitTypes.SET_SUPERVISION_CLIENT](state, client) {
        state.supervisionClient = client
    },
    [commitTypes.ADD_ACTIVE_REQUESTS](state) {
        state.activeRequests = state.activeRequests + 1
    },
    [commitTypes.SUB_ACTIVE_REQUESTS](state) {
        state.activeRequests = state.activeRequests - 1
    },
    [commitTypes.SET_CURRENT_EVALUATION](state, evaluation) {
        state.currentEvaluation = evaluation
        statelocalstorage(state)
    },
    [commitTypes.SET_CURRENT_EVALUATED_USER](state, subordinate) {
        state.currentEvaluatedUser = subordinate
        statelocalstorage(state)
    },
}
